import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AmusementServiceReserveItem`;

const ApiAmusementServiceReserveItem = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  getAllReserveItems: (serviceId) => {
    const url = `${baseServiceUrl}/getAllAmusementReserveItems/${serviceId}`;
    return ServiceApi.get(url);
  },
  get: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.get(url);
  },
  create: (params) => {
    const url = `${baseServiceUrl}/createAmusementServiceReserveItem`;
    return ServiceApi.post(url, params);
  },
  update: (id, params) => {
    const url = `${baseServiceUrl}/updateAmusementServiceReserveItem`;
    return ServiceApi.put(url, params);
  },
  updateStatusAmusementServiceReserveItem: (params) => {
    const url = `${baseServiceUrl}/updateStatusAmusementServiceReserveItem`;
    return ServiceApi.put(url, params);
  },
  changeOrderAmusementServiceReserveItem: (params) => {
    const url = `${baseServiceUrl}/changeOrderAmusementServiceReserveItems`;
    return ServiceApi.post(url, params);
  },
  updateAmusementServiceReserveItemInGrouping: (params) => {
    const url = `${baseServiceUrl}/updateAmusementServiceReserveItemInGrouping`;
    return ServiceApi.put(url, params);
  },
  getAmusementServiceReserveItemAndCommissions: (id) => {
    const url = `${baseServiceUrl}/getAmusementServiceReserveItemAndCommissions/${id}`;
    return ServiceApi.get(url);
  },
  updateReserveItemPricingAndCommission: (params) => {
    const url = `${baseServiceUrl}/updateAmusementServiceReserveItemAndCommissions`;
    return ServiceApi.put(url, params);
  },
  updateAmusementServiceReserveItemsByExcel: (params) => {
    const url = `${baseServiceUrl}/updateAmusementServiceReserveItemsByExcel`
    return ServiceApi.post(url, params)
  },
  getAllServicesWithItemsByCityId: (params) => {
    const url = `${baseServiceUrl}/getAllServicesWithItemsByCityId`
    return ServiceApi.get(url, { params })
  }
};

export default ApiAmusementServiceReserveItem;


